import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=3c7c5944"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports